import { render, staticRenderFns } from "./PT151HtmlNoEditParts.vue?vue&type=template&id=731d1836&"
import script from "./PT151HtmlNoEditParts.vue?vue&type=script&lang=js&"
export * from "./PT151HtmlNoEditParts.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports